module.exports = __webpack_public_path__ + "static/media/lightning_avacon.a72c291b.svg";